import { Reducer, Action } from 'redux';
import {
  PractitionerSpecialtyAssociationState,
  PractitionerSpecialtyAssociationUnloadState
} from '../states/PractitionerSpecialtyAssociationState';
import { PractitionerSpecialtyAssociation } from '../../models/Entities/PractitionerAssociations/Specialties/PractitionerSpecialtyAssociation';

// Actions
import * as Actions from '../actions';

type KnownAction =
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_RequestAll_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_ReceiveAll_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_FailAll_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Add_Request_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Add_Receive_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Add_Fail_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Delete_Request_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Delete_Receive_Action
  | Actions.PractitionerSpecialtyAssociations.PractitionerSpecialty_Delete_Fail_Action;

export const PractitionerSpecialtyAssociationReducer: Reducer<PractitionerSpecialtyAssociationState> = (
  state: PractitionerSpecialtyAssociationState | undefined,
  incomingAction: Action
): PractitionerSpecialtyAssociationState => {
  if (state === undefined) {
    return PractitionerSpecialtyAssociationUnloadState;
  }

  const action = incomingAction as KnownAction;
  switch (action.type) {
    case 'PRACTITIONER_SPECIALTY_REQUEST_ALL_ACTION':
      return {
        ...state,
        isLoadingAll: true,
        successLoadingAll: undefined,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'PRACTITIONER_SPECIALTY_RECEIVE_ALL_ACTION':
      return {
        ...state,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined,
        list: action.practitionerSpecialties
      };
    case 'PRACTITIONER_SPECIALTY_FAIL_ALL_ACTION':
      return {
        ...state,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: action.error
      };
    case 'PRACTITIONER_SPECIALTY_ADD_REQUEST_ACTION':
      return {
        ...state,
        isAddingNewOne: true,
        successAddingNewOne: undefined,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'PRACTITIONER_SPECIALTY_ADD_RECEIVE_ACTION':
      return {
        ...state,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        error: undefined,
        list: [...state.list, action.practitionerSpecialty]
      };
    case 'PRACTITIONER_SPECIALTY_ADD_FAIL_ACTION':
      return {
        ...state,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: action.error
      };
    case 'PRACTITIONER_SPECIALTY_DELETE_REQUEST_ACTION':
      return {
        ...state,
        isDeletingOne: true,
        successDeletingOne: undefined,
        failOnDeletingOne: false,
        error: undefined
      };
    case 'PRACTITIONER_SPECIALTY_DELETE_RECEIVE_ACTION':
      return {
        ...state,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        error: undefined,
        list: state.list.filter(
          (item: PractitionerSpecialtyAssociation) =>
            item.id !== action.practitionerSpecialtyId
        )
      };
    case 'PRACTITIONER_SPECIALTY_DELETE_FAIL_ACTION':
      return {
        ...state,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: action.error
      };
    default:
      return state;
  }
};
